import { useTheme } from '@mui/styles';
import { Cancel } from '@tassat/icon';
import { muiTheme } from '@tassat/payments-themes';
import React from 'react';

import muiStyles from './styles';
import { CancelButtonProps } from './types';

export const CancelButton = (props: CancelButtonProps) => {
    const {
        iconColor,
        onClick
    } = props;

    const classes = muiStyles(props);

    return (
        <Cancel
            className={classes.root}
            iconColor={iconColor || '#000'}
            onClick={onClick}
        />
    );
};

export const CancelBlack = (props: CancelButtonProps) => {
    const { onClick } = props;

    const theme = useTheme<typeof muiTheme>();

    return (
        <CancelButton
            iconColor={theme?.app?.applicationColors.enumColors.black || '#000'}
            onClick={onClick}
        />
    );
};

export const CancelWhite = (props: CancelButtonProps) => {
    const { onClick } = props;

    const theme = useTheme<typeof muiTheme>();

    return (
        <CancelButton
            iconColor={theme?.app?.applicationColors.enumColors.white || '#FFF'}
            onClick={onClick}
        />
    );
};

export const CancelGrey = (props: CancelButtonProps) => {
    const { onClick } = props;

    const theme = useTheme<typeof muiTheme>();

    return (
        <CancelButton
            iconColor={theme?.app?.applicationColors.enumColors.greyLight || '#a7a7a7'}
            onClick={onClick}
        />
    );
};